import {
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React from "react";
import AppButton from "@/features/line-sheet-sets/app-button";
import AppInvoiceStatusLabel from "@/features/ui/app-invoice-status-label";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import useDownloadUnoFile from "@/hooks/use-download-uno-file";
import { ProformaInvoice } from "@/features/invoices/proforma-invoices/proforma-invoice.type";
import SummaryRows, {
  SummaryRow,
} from "@/features/line-sheet-sets/detail/summary-rows";

interface Props {
  proformaInvoice?: ProformaInvoice;
  isOpen: boolean;
  onClose: () => void;
}

// (부티크) 오더 상세의 프로포마 탭에서 행을 누르면 — 상세 페이지 대신 핵심 항목만 보여준다.
export default function BoutiqueProformaInvoiceSummaryModal({
  proformaInvoice,
  isOpen,
  onClose,
}: Props) {
  const { t, tTitle, tLocalDateString, tCurrencyString } = useI18nHelper();
  const { fire: fireDownloadUnoFile } = useDownloadUnoFile();

  const file = proformaInvoice?.file ?? null;
  const rows: SummaryRow[] = proformaInvoice
    ? [
        { label: tTitle("name"), value: proformaInvoice.name },
        { label: tTitle("invoice_number"), value: proformaInvoice.number },
        {
          label: tTitle("issued_on"),
          value: tLocalDateString(proformaInvoice.issuedOn),
        },
        { label: tTitle("issued_by"), value: proformaInvoice.issuedByCompany?.name },
        { label: tTitle("issued_to"), value: proformaInvoice.issuedToCompany?.name },
        {
          label: tTitle("amount"),
          value: tCurrencyString(proformaInvoice.totalAmount.value, {
            type: "SYMBOL",
            code: proformaInvoice.totalAmount.currency,
          }),
        },
        {
          label: tTitle("status"),
          value: <AppInvoiceStatusLabel value={proformaInvoice.status} />,
        },
        {
          label: tTitle("paid_by"),
          value: t(proformaInvoice.paidBy.toLowerCase(), {
            defaultValue: proformaInvoice.paidBy,
          }),
        },
        {
          label: tTitle("file"),
          value: file ? (
            <AppButton
              variant={"white"}
              size={"small"}
              onClick={() => fireDownloadUnoFile({ unoFileId: file.id }, {})}
            >
              {file.name}
            </AppButton>
          ) : (
            ""
          ),
        },
      ]
    : [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={"lg"}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize={"16px"} fontWeight={"700"}>
          {tTitle("proforma_invoice")}
        </ModalHeader>
        <ModalBody>
          {proformaInvoice ? (
            <SummaryRows rows={rows} />
          ) : (
            <Text fontSize={"12px"}>-</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Grid>
            <AppButton onClick={onClose}>{tTitle("close")}</AppButton>
          </Grid>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
